import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@mellify/ui';
import { CreateWorkspaceModal } from './workspaces/CreateWorkspaceModal';

/**
 * WorkspacesPageActions
 *
 * Header actions for the Workspaces page.
 * Renders a "Create Workspace" button that opens the creation wizard.
 */
export const WorkspacesPageActions: React.FC = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  return (
    <>
      <Button
        variant="primary"
        size="md"
        leftIcon={<Plus className="w-4 h-4" />}
        onClick={() => setIsCreateOpen(true)}
      >
        Create Workspace
      </Button>

      <CreateWorkspaceModal
        open={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
      />
    </>
  );
};

export default WorkspacesPageActions;